import { initializePermissionApi, PermissionApi } from '@data-delivery/permission-ui-api';
import { queryOptions } from '@tanstack/react-query';

const assignmentsApi = initializePermissionApi(PermissionApi.AssignmentsApi);

export const assignmentsKeys = {
  all: () => ['assignments'] as const,
  list: () => [...assignmentsKeys.all(), 'list'] as const,
  byId: (id: string) => [...assignmentsKeys.all(), 'by-id', id] as const,
  byBusinessGroup: (businessGroupId: string) =>
    [...assignmentsKeys.all(), 'by-bg', businessGroupId] as const,
  searchByName: (name: string) => [...assignmentsKeys.all(), 'search-name', name] as const,
};

export const assignmentsQueries = {
  list: () =>
    queryOptions({
      queryKey: assignmentsKeys.list(),
      async queryFn() {
        const { data } = await assignmentsApi.getAllAssignments();
        return data ?? [];
      },
      staleTime: 60_000,
    }),
  byId: (id: string) =>
    queryOptions({
      queryKey: assignmentsKeys.byId(id),
      enabled: Boolean(id),
      async queryFn() {
        const { data } = await assignmentsApi.getAssignmentById({ id });
        return data ?? null;
      },
    }),
  byBusinessGroup: (businessGroupId: string) =>
    queryOptions({
      queryKey: assignmentsKeys.byBusinessGroup(businessGroupId),
      enabled: Boolean(businessGroupId),
      async queryFn() {
        const { data } = await assignmentsApi.getAssignmentsByBusinessGroupId({ businessGroupId });
        return data ?? [];
      },
    }),
  searchByName: (name: string) =>
    queryOptions({
      queryKey: assignmentsKeys.searchByName(name),
      enabled: Boolean(name) && name.trim().length > 0,
      async queryFn() {
        const { data } = await assignmentsApi.searchAssignmentByName({ name });
        return data ?? [];
      },
    }),
};
